import { render, staticRenderFns } from "./notificationIntro.vue?vue&type=template&id=4956cac0&"
import script from "./notificationIntro.vue?vue&type=script&lang=js&"
export * from "./notificationIntro.vue?vue&type=script&lang=js&"
import style0 from "./notificationIntro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports